import { render, staticRenderFns } from "./SendZapi.vue?vue&type=template&id=d084b454&"
import script from "./SendZapi.vue?vue&type=script&lang=js&"
export * from "./SendZapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports